import localforage from "localforage";

class _SaveLoadManager {
    private _gameData: GameData;
    private _scene: Phaser.Scene;
    public zoomCameraLevel:number[]=[1.0,1.4,1.8,2.2,2.6,3.0];

    public extraTimeAfterWatchingAd:number=20;
    public minEnemyCountLevel1To5:number=2;     //2 & 5
    public maxEnemyCountLevel1To5:number=5;

    public minEnemyCountLevel5To10:number=3;
    public maxEnemyCountLevel5To10:number=6;

    public minEnemyCountLevel10To15:number=4;
    public maxEnemyCountLevel10To15:number=7;

    public minEnemyCountLevel15To20:number=5;
    public maxEnemyCountLevel15To20:number=8;

    public minEnemyCountLevel20To25:number=6;
    public maxEnemyCountLevel20To25:number=9;

    public minEnemyCountLevel25To30:number=7;
    public maxEnemyCountLevel25To30:number=10;

    public minEnemyCountLevel30To35:number=8;
    public maxEnemyCountLevel30To35:number=11;

    public minEnemyCountLevel35To40:number=9;
    public maxEnemyCountLevel35To40:number=12;

    public minEnemyCountLevel40To45:number=10;
    public maxEnemyCountLevel40To45:number=13;

    public minEnemyCountLevel45To50:number=11;
    public maxEnemyCountLevel45To50:number=14;

    public minEnemyCountLevel50To55:number=12;
    public maxEnemyCountLevel50To55:number=15;

    public minEnemyCountLevel55To60:number=13;
    public maxEnemyCountLevel55To60:number=16;

    public minEnemyCountLevel60To65:number=14;
    public maxEnemyCountLevel60To65:number=17;

    public minEnemyCountLevel65To70:number=15;
    public maxEnemyCountLevel65To70:number=18;

    public minEnemyCountLevel70To75:number=16;
    public maxEnemyCountLevel70To75:number=19;

    public minEnemyCountLevel75To80:number=17;
    public maxEnemyCountLevel75To80:number=20;


    public maxEnemiesInWorld1:number=20;
    public maxEnemiesInWorld2:number=20;
    public maxEnemiesInWorld3:number=20;
    public maxEnemiesInWorld4:number=20;
    public maxEnemiesInWorld5:number=20;



    get GameData() {
        return this._gameData;
    }

    private _key: string;


    init(scene: Phaser.Scene, key: string) 
    {
        this._scene = scene;
        this._key = key;

        //@ts-ignore
        window.snapshot = () => {
            console.log(this._gameData);
        }

        //@ts-ignore
        window.overwrite = (data: GameData) => {
            this._gameData = data;
            this.save();
        }
    }

    async save(): Promise<void> {
        await localforage.setItem(this._key, this._gameData);
        console.log('Game Data after saving\nversion: '+this._gameData.version+'\nfirst time: '+this._gameData.firstTime+'\nsound muted: '+this._gameData.soundMuted+'\nlevel no: '+this._gameData.levelNo+'\ngun zoom: '+this._gameData.gunZoom+'\npoints: '+this._gameData.points+'\nenemy difficulty: '+this._gameData.enemyDifficulty+'\nscope upgrade timer value: '+this._gameData.scopeUpgradeTimerValue+'\ntime upgrade timer value: '+this._gameData.timeUpgradeTimerValue);
        
    }

    async load() {
        this._gameData = {
            version: this._scene.game.config.gameVersion,
            firstTime: true,
            soundMuted: false,
            levelNo:1,
            gunZoom:1,
            maxgunZoom:26,
            maxGunZoomUnlocked :1,
            points:0,
            // difficultyConstant:4,//8
            enemyDifficulty:1,
            maxEnemyDifficulty:9,
            scopeUpgradeTimerValue:0,
            timeUpgradeTimerValue:0,
            pointsRequiredForZoomUpgrade:300,//300
            pointsRequiredForTimeUpgrade:300,//300
            zoomUsingAdsCoolDownDuration: 60000,//60000
            timeUsingAdsCoolDownDuration: 60000,//60000
        };

        const gd = await localforage.getItem<GameData>(this._key);
        if (gd) {
            this._upgradeGameDataToLatestVersion(gd);
            if (!gd.adCooldownTimestamp) {
                gd.adCooldownTimestamp = 0;
    }
    if (!gd.adCooldownTimestampTime) {
                gd.adCooldownTimestampTime = 0;
    }
        }
        
        console.log('Game Data after loading\nversion: '+this._gameData.version+'\nfirst time: '+this._gameData.firstTime+'\nsound muted: '+this._gameData.soundMuted+'\nlevel no: '+this._gameData.levelNo+'\ngun zoom: '+this._gameData.gunZoom+'\npoints: '+this._gameData.points+'\nenemy difficulty: '+this._gameData.enemyDifficulty+'\nscope upgrade timer value: '+this._gameData.scopeUpgradeTimerValue+'\ntime upgrade timer value: '+this._gameData.timeUpgradeTimerValue);
        
    }

async clearSaveData() {
        await localforage.clear();
    }

    private _upgradeGameDataToLatestVersion(gameData: GameData) {
        // if (gameData.version === this._gameData.version) {
        this._gameData.firstTime = gameData.firstTime;
        this._gameData.soundMuted = gameData.soundMuted;
        this._gameData.version = gameData.version;
        this._gameData.levelNo=gameData.levelNo;
        this._gameData.maxgunZoom=gameData.maxgunZoom;
        this._gameData.maxGunZoomUnlocked =gameData.maxGunZoomUnlocked ;
        this._gameData.gunZoom=gameData.gunZoom;
        this._gameData.points=gameData.points;
        // this._gameData.difficultyConstant=gameData.difficultyConstant;
        this._gameData.enemyDifficulty=gameData.enemyDifficulty;
        this._gameData.maxEnemyDifficulty=gameData.maxEnemyDifficulty;
        this._gameData.scopeUpgradeTimerValue=gameData.scopeUpgradeTimerValue;
        this._gameData.timeUpgradeTimerValue=gameData.timeUpgradeTimerValue;
        this._gameData.pointsRequiredForZoomUpgrade=gameData.pointsRequiredForZoomUpgrade;
        this._gameData.pointsRequiredForTimeUpgrade=gameData.pointsRequiredForTimeUpgrade;
        this._gameData.zoomUsingAdsCoolDownDuration=gameData.zoomUsingAdsCoolDownDuration;
         this._gameData.timeUsingAdsCoolDownDuration=gameData.timeUsingAdsCoolDownDuration;
        this._gameData.adCooldownTimestamp = gameData.adCooldownTimestamp ?? 0;
        this._gameData.adCooldownTimestampTime = gameData.adCooldownTimestampTime ?? 0;
        
        // } else {

        // }
    }


}


export const SaveLoadManager = new _SaveLoadManager();

export type GameData = {
    version: string;
    firstTime: boolean;
    soundMuted: boolean;
    levelNo: integer;
    maxgunZoom:integer;
    gunZoom:integer;
    maxGunZoomUnlocked :integer;
    points:integer;
    // difficultyConstant:integer;
    enemyDifficulty:integer;
    maxEnemyDifficulty:integer;
    scopeUpgradeTimerValue:integer;
    timeUpgradeTimerValue:integer;
    pointsRequiredForZoomUpgrade:integer;
    pointsRequiredForTimeUpgrade:integer;
    zoomUsingAdsCoolDownDuration:integer;
    timeUsingAdsCoolDownDuration:integer;
     adCooldownTimestamp?: number;
     adCooldownTimestampTime?: number;
}